<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert')">Carl Von
                        Schubert
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/egon-muller')">Egon Müller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/jj-prum')">J.J. Prüm
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/peter-lauer')">Peter Lauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/van-volxem')">Van Volxem
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken')">
                        Weingut Forstmeister Geltz Zilliken
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch')">Wwe. Dr. H.
                        Thanisch, Erben Thanisch
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/mosel-saar-ruwer')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Egon Müller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Indossando con orgoglio la corona del vino più costoso della Germania - e in alcuni casi del mondo -,
                        Egon Muller ha qualcosa per cui sorridere. Raggiungendo spesso quotazioni strategarie in asta, esso
                        si potrebbe dire che quando si tratta di Riesling, Egon non ha nulla di cui "vincere".
                    </div>

                    <div class="howto-title2">Una famiglia di Egon</div>
                    <div class="howto-text">
                        Una dinastia del vino dal 1797, l'attuale Egon Muller è Egon Muller IV, e il
                        pronipote di Egon Müller I. Come molte altre proprietà nella regione della Saar, il terreno
                        in precedenza era di proprietà del clero, e lo fu solo allo scioglimento di diverse napoleoniche
                        le leggi hanno messo in vendita la terra. Così, alla fine del XVIII secolo, i Muller divennero proprietari terrieri
                        - e produttori di vino per l'avvio. Egon IV è subentrato a Egon III (suo padre) nel 1991.
                    </div>

                    <div class="howto-title2">I migliori vini del loro decennio</div>
                    <div class="howto-text">
                        Il successo di Muller è triplice. Uno; i suoi otto ettari di terreno in ardesia tra 190 e 310
                        metri di altitudine significa drenaggio superbo. Due; i pendii esposti a sud consentono lunghe percorrenze
                        maturazione, che a sua volta sottolinea il vino con il profumo fine. Tre; La finezza di Muller come a
                        enologo ha sedotto critici e intenditori di tutto il mondo. Tuttavia, quanto uno
                        ama l'attuale Egon (ci sono anche due fratelli che si chiamano Egon, entrambi banchieri), lo è davvero
                        solo costruendo sulle fondamenta di suo padre. Tornato dalla guerra nel 1945, Egon III
                        si accinse a restaurare la proprietà di famiglia e iniziò il reimpianto. Fu allora che accadde la magia.
                        Seguirono diverse annate importanti: la 1949, la 1951 (anno di nascita di Egon IV), la 1971
                        e il 1983 sono probabilmente i migliori (ergo, i più costosi) vini del loro decennio. Sono
                        sicuramente i migliori Riesling.
                    </div>

                    <div class="howto-title2">Il vino più costoso della Germania</div>
                    <div class="howto-text">
                        Non sorprenderà quindi che anche i vini entry level siano costosi. Ma ugualmente, meritato: il favoloso invecchiamento insieme alla superba reputazione significa che una bottiglia di Egon Müller-Scharzhof, Scharzhofberger Riesling Trockenbeerenauslese (forse il 2017?) Sarà la più grande aggiunta che tu abbia mai fatto al tuo portafoglio di vini. Avrai bisogno di tasche profonde però; nel secondo trimestre 2019 i prezzi hanno superato i 16.500 euro a bottiglia, e sono destinati a salire.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Auslese Goldkapsel viene prodotto solo nelle migliori annate. Beerenauslese,
                                Se le condizioni lo consentono, vengono prodotti anche Trockenbeerenauslese ed Eiswein.
                            </li>
                            <li>Nonostante i vigneti siano classificati come Grosses Gewachs, i vini che producono possono
                                non essere etichettati come tali a causa degli zuccheri residui che tendono a presentare in Muller's
                                Spatlese e Auslese.
                            </li>
                            <li>Un lotto di tre bottiglie di Scharzhofberger Riesling Auslese del 1990 è stato venduto per € 3.552 a
                                asta/Sotheby's NY - ben al di sopra della stima di 900 - 1.300 USD (da circa € 806 a € 1.164).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Egon Müller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Stolz trägt er die Krone des teuersten Weines Deutschlands – und in manchen Fällen sogar der Welt –,
                        Egon Müller hat etwas zum Schmunzeln. Es erzielt bei Auktionen oft katastrophale Preise
                        Man könnte sagen, dass Egon in Sachen Riesling nichts zu bemängeln hat.
                    </div>

                    <div class="howto-title2">Eine Familie von Egons</div>
                    <div class="howto-text">
                        Eine Weindynastie seit 1797, der aktuelle Egon Müller ist Egon Müller IV. und der
                        Ururenkel von Egon Müller I. Wie viele andere Anwesen im Saargebiet auch das Grundstück
                        war zuvor im Besitz des Klerus und wurde erst nach der Auflösung mehrerer napoleonischer Herrschaften gegründet
                        Nach welchen Gesetzen stand das Land zum Verkauf? So wurden die Mullers im späten 18. Jahrhundert Grundbesitzer
                        - und Winzer obendrein. Egon der Vierte trat 1991 die Nachfolge von Egon dem Dritten (seinem Vater) an.
                    </div>

                    <div class="howto-title2">Die besten Weine ihres Jahrzehnts</div>
                    <div class="howto-text">
                        Müllers Erfolg ist dreifach. Eins; seine acht Hektar Schieferboden zwischen 190 und 310
                        Höhenmeter bedeuten eine hervorragende Entwässerung. Zwei; Die nach Süden ausgerichteten Hänge ermöglichen längere Aufenthalte
                        Reifung, die wiederum den Wein mit seinem feinen Duft unterstreicht. Drei; Mullers Finesse als
                        Der Winzer hat sowohl Kritiker als auch Kenner auf der ganzen Welt verführt. Allerdings so viel wie eins
                        liebt den jetzigen Egon (es gibt auch zwei Brüder namens Egon, beide Banker), er ist es wirklich
                        baute einfach auf den Grundlagen seines Vaters auf. 1945 aus dem Krieg zurückgekehrt, wurde Egon III
                        machte sich an die Restaurierung des Familienbesitzes und begann mit der Neubepflanzung. Dies war, als die Magie geschah.
                        Es folgten mehrere bedeutsame Jahrgänge: der 1949, der 1951 (das Geburtsjahr von Egon IV.) und der 1971
                        und der 1983er sind wahrscheinlich die besten (also teuersten) Weine ihres Jahrzehnts. Sie sind
                        sicherlich die besten Rieslinge.
                    </div>

                    <div class="howto-title2">Deutschlands teuerster Wein</div>
                    <div class="howto-text">
                        Es wird daher nicht überraschen, dass selbst Weine der Einstiegsklasse teuer sind. Aber ebenso verdient: Die fabelhafte Reifung und der hervorragende Ruf bedeuten, dass eine Flasche Egon Müller-Scharzhof, Scharzhofberger Riesling Trockenbeerenauslese (vielleicht die 2017er?), die größte Ergänzung Ihres Weinportfolios sein wird. Sie benötigen jedoch tiefe Taschen; Im zweiten Quartal 2019 lagen die Preise bei über 16.500 € pro Flasche, Tendenz steigend.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Auslese Goldkapsel wird nur in den besten Jahrgängen hergestellt. Beerenauslese,
                                Sofern die Bedingungen es zulassen, werden auch Trockenbeerenauslesen und Eiswein produziert.
                            </li>
                            <li>Obwohl die Weinberge als „Großes Gewächs“ eingestuft sind, können die Weine, die sie produzieren, möglicherweise nicht ausgebaut werden
                                Aufgrund des Restzuckers, der normalerweise in Muller’s enthalten ist, darf das Produkt nicht als solches gekennzeichnet werden
                                Spatlese und Auslese.
                            </li>
                            <li>Ein Drei-Flaschen-Lot der Scharzhofberger Riesling Auslese aus dem Jahr 1990 wurde für 3.552 € verkauft
                                Auktion/Sotheby’s NY – deutlich über der Schätzung von 900 – 1.300 USD (ca. 806 bis 1.164 €).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Egon Müller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Portant fièrement la couronne du vin le plus cher d'Allemagne - et dans certains cas du monde -,
                        Egon Muller a de quoi sourire. Atteignant souvent des prix stratostrophiques aux enchères, il
                        On pourrait dire qu'en matière de Riesling, Egon n'a rien à "viner".
                    </div>

                    <div class="howto-title2">Une famille d'Egons</div>
                    <div class="howto-text">
                        Dynastie viticole depuis 1797, l'actuel Egon Muller est Egon Muller IV, et le
                        arrière-arrière-petit-fils d'Egon Müller I. Comme beaucoup d'autres propriétés en Sarre, le terrain
                        appartenait auparavant au clergé, et ce n'est qu'à la dissolution de plusieurs napoléoniens
                        lois, la terre a-t-elle été mise en vente. Ainsi à la fin du 18ème siècle, les Muller deviennent propriétaires terriens
                        - et vignerons en prime. Egon IV a succédé à Egon III (son père) en 1991.
                    </div>

                    <div class="howto-title2">Les meilleurs vins de leur décennie</div>
                    <div class="howto-text">
                        Le succès de Muller est triple. Un; ses huit hectares de sol ardoisier entre 190 et 310
                        mètres d'altitude signifie un excellent drainage. Deux; les pentes exposées au sud permettent de longues
                        maturation, qui à son tour souligne le vin au parfum fin. Trois; La finesse de Muller comme
                        vigneron a séduit critiques et connaisseurs du monde entier. Cependant, autant qu'un
                        aime l'Egon actuel (il y a aussi deux frères qui s'appellent Egon, tous deux banquiers), il est vraiment
                        en train de construire sur les fondations de son père. De retour de la guerre en 1945, Egon le 3
                        s'attache à restaurer la propriété familiale et commence à replanter. C'est alors que la magie s'est opérée.
                        Suivent plusieurs millésimes marquants : le 1949, le 1951 (l'année de la naissance d'Egon IV), le 1971
                        et le 1983 sont probablement les meilleurs vins (c'est-à-dire les plus chers) de leur décennie. Ils sont
                        certainement les meilleurs Rieslings.
                    </div>

                    <div class="howto-title2">Le vin le plus cher d'Allemagne</div>
                    <div class="howto-text">
                        Il ne sera donc pas surprenant que même les vins d'entrée de gamme soient chers. Mais tout aussi mérité - un vieillissement fabuleux associé à une superbe réputation signifie qu'une bouteille d'Egon Müller-Scharzhof, Scharzhofberger Riesling Trockenbeerenauslese (peut-être le 2017 ?) sera le plus grand ajout que vous ferez jamais à votre portefeuille de vins. Vous aurez cependant besoin de poches profondes; au deuxième trimestre 2019, les prix étaient supérieurs à 16 500 € la bouteille et devraient augmenter.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Auslese Goldkapsel est produit uniquement dans les meilleurs millésimes. Beerenauslese,
                                Trockenbeerenauslese et Eiswein sont également produits si les conditions le permettent.
                            </li>
                            <li>Bien que les vignobles soient classés comme Grosses Gewachs, les vins qu'ils produisent peuvent
                                ne pas être étiqueté comme tel en raison des sucres résiduels qui ont tendance à être présents dans le
                                Spatlese et Auslese.
                            </li>
                            <li>Un lot de trois bouteilles de Scharzhofberger Riesling Auslese 1990 vendu 3552€ à
                                enchères/Sotheby's NY - bien au-dessus de l'estimation de 900 - 1 300 USD (environ 806 € à 1 164 €).
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Egon Müller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Proudly wearing the crown of Germany’s - and in certain cases the World’s - most expensive wine,
                        Egon Muller has something to smile about. Often reaching stratestrophic prices at auction, it
                        could be said that when it comes to Riesling, Egon has nothing to “wine” about.
                    </div>

                    <div class="howto-title2">A family of Egons</div>
                    <div class="howto-text">
                        A wine dynasty since 1797, the current Egon Muller is Egon Muller IV, and the
                        great-great-grandson of Egon Müller I. Like many other properties in the Saar region, the land
                        was previously owned by the clergy, and it was only upon the dissolution of several Napoleonic
                        laws did the land come up for sale. Thus in the late 18th century, the Mullers became landowners
                        - and winemakers to boot. Egon the 4th took over from Egon the 3rd (his father) in 1991.
                    </div>

                    <div class="howto-title2">The best wines of their decade</div>
                    <div class="howto-text">
                        Muller’s success is threefold. One; his eight hectares of slate soil at between 190 and 310
                        metres of altitude means superb drainage. Two; the south-facing slopes allow for lengthy
                        ripening, which in turn underscores the wine with the fine perfume. Three; Muller’s finesse as a
                        winemaker has seduced both critics and connoisseurs the world over. However, as much as one
                        loves the current Egon (there are also two brothers called Egon, both bankers), he is really
                        just building on his father’s foundations. Having returned from the war in 1945, Egon the 3rd
                        set to restoring the family property, and begun replanting. This was when the magic happened.
                        Several momentous vintages followed: the 1949, the 1951 (the year Egon IV was born), the 1971
                        and the 1983 are likely the best (ergo, most expensive) wines of their decade. They are
                        certainly the best Rieslings.
                    </div>

                    <div class="howto-title2">Germany’s most expensive wine</div>
                    <div class="howto-text">
                        It will not come as a surprise then that even entry level wines are expensive. But equally, merited - fabulous aging along with the superb reputation means a bottle of Egon Müller-Scharzhof, Scharzhofberger Riesling Trockenbeerenauslese (perhaps the 2017?) will be the greatest addition you’ll ever make to your wine portfolio. You’ll need deep pockets though; in Q2 2019 prices were over €16,500 a bottle, and set to rise.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Auslese Goldkapsel is produced only in the best vintages. Beerenauslese,
                                Trockenbeerenauslese and Eiswein are also produced if conditions permit.
                            </li>
                            <li>Despite the vineyards being classified as Grosses Gewachs, the wines they produce may
                                not be labelled as such due to the residual sugars which tend to present in Muller’s
                                Spatlese and Auslese.
                            </li>
                            <li>A three-bottle lot of 1990 Scharzhofberger Riesling Auslese sold for €3,552 at
                                auction/Sotheby’s NY - well above the 900 - 1,300 USD (approx €806 to €1,164) estimate.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EgonMuller",
    data() {
        return {
            select: {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
            items: [
                {report: 'Carl Von Schubert', src: '/wine-guide/germany/mosel-saar-ruwer/carl-von-schubert'},
                {report: 'Egon Müller', src: '/wine-guide/germany/mosel-saar-ruwer/egon-muller'},
                {report: 'J.J. Prüm', src: '/wine-guide/germany/mosel-saar-ruwer/jj-prum'},
                {report: 'Peter Lauer', src: '/wine-guide/germany/mosel-saar-ruwer/peter-lauer'},
                {report: 'Van Volxem', src: '/wine-guide/germany/mosel-saar-ruwer/van-volxem'},
                {
                    report: 'Weingut Forstmeister Geltz Zilliken',
                    src: '/wine-guide/germany/mosel-saar-ruwer/weingut-forstmeister-geltz-zilliken'
                },
                {
                    report: 'Wwe. Dr. H. Thanisch, Erben Thanisch',
                    src: '/wine-guide/germany/mosel-saar-ruwer/wwe-thanisch'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Egon Müller | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exquisite wines of Egon Müller, a renowned wine producer in the Mosel wine region. With a commitment to traditional winemaking techniques and a passion for quality, Egon Müller produces some of the finest Riesling wines in the world. Explore their range of wines and taste the difference of their expertise.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
